import { ActionIcon } from '@mantine/core';
import { Editor } from 'slate';
import { useSlate } from 'slate-react';

import styles from './RichTextEditorMarkButton.module.scss';
import { Props } from './RichTextEditorMarkButton.types';

const isMarkActive = (editor: Editor, format: string) => {
  const marks = Editor.marks(editor);
  return marks ? marks[format as keyof typeof marks] === true : false;
};

const toggleMark = (editor: Editor, format: string) => {
  const isActive = isMarkActive(editor, format);

  if (isActive) {
    Editor.removeMark(editor, format);
  } else {
    Editor.addMark(editor, format, true);
  }
};
const RichTextEditorMarkButton = ({ format, icon }: Props) => {
  const editor = useSlate();
  return (
    <ActionIcon
      className={styles.button}
      variant={isMarkActive(editor, format) ? 'light' : 'transparent'}
      onMouseDown={event => {
        event.preventDefault();
        toggleMark(editor, format);
      }}
      size={24}
    >
      <img src={icon} className={styles.icon} />
    </ActionIcon>
  );
};

export default RichTextEditorMarkButton;
